import { z } from 'zod'

export const formSchema = z.object({
  interestedIn: z.union([
    z.array(z.string()).min(1, { message: 'Please select at least one option' }),
    z
      .string()
      .transform((str) => str.split(',').filter(Boolean))
      .refine((arr) => arr.length >= 1, {
        message: 'Please select at least one option',
      }),
  ]),
  company: z.string().min(1, { message: 'Please enter your company name' }),
  firstName: z.string().min(1, { message: 'Please enter your first name' }),
  lastName: z.string().min(1, { message: 'Please enter your last name' }),
  email: z.string().email({ message: 'Please enter a valid email address' }),
  useCase: z.union([
    z.array(z.string()).min(1, { message: 'Please select at least one option' }),
    z
      .string()
      .transform((str) => str.split(',').filter(Boolean))
      .refine((arr) => arr.length >= 1, {
        message: 'Please select at least one option',
      }),
  ]),
  useCaseDescription: z.string().min(1, { message: 'Please enter a description' }),
  newsletterSubscribe: z
    .union([z.string().transform((val) => val === 'true'), z.boolean()])
    .optional(),
  acceptTerms: z.union([
    z.string().refine((val) => val === 'true', {
      message: 'Please accept the privacy policy',
    }),
    z.boolean().refine((val) => val === true, {
      message: 'Please accept the privacy policy',
    }),
  ]),
  orderVolume: z.string().min(1, { message: 'Please select an order volume' }),
  companySize: z.string().min(1, { message: 'Please select a company size' }),
})
